module.exports = __webpack_public_path__ + "img/romance.3841409e.svg";